import { loginApi } from '../../setup/setupApi';

export type MfaValue = {
  mfa_types: MfaType[];
  mfa_url?: string;
};

export type MfaType = {
  mfa_type: string;
  priority: number;
};

export const getMfaSettings = (projectId: string): Promise<MfaValue> =>
  loginApi.get(`projects/${projectId}/mfa`).then((res) => res.data);

export const setMfaSettings = (projectId: string, values: MfaValue): Promise<MfaValue> =>
  loginApi.put(`projects/${projectId}/mfa`, values).then((res) => res.data);
